import Vue from 'vue/dist/vue.min.js';
import VModal from 'vue-js-modal';
import { videoModal } from './modals';



const Slideshow = () => {
    const slideshowEl = document.getElementById('slideshow-slider')
    if (!slideshowEl) return;
    const slidesEl = slideshowEl.querySelectorAll('.slider-slides .slide');

    const SlideshowConstructor = () => {
        let activeSlide = 1;
        const arrowL = slideshowEl.querySelector('.slider-controls .arrow.L');
        const arrowR = slideshowEl.querySelector('.slider-controls .arrow.R');
        const pausePlay = slideshowEl.querySelector('.slider-controls .circular-progress');
        const totalSlides = slidesEl.length;
        const slidesVideos = slideshowEl.querySelectorAll('video');
        const modalTriggers = document.querySelectorAll('.video-player-link button')

        const circle = slideshowEl.querySelector('.slider-controls circle.fg');
        const circleSize = 30; // this is the width and height of svg (should be a square that fits the circle)
        const strokeW = 2
        const radius = (circleSize - strokeW) / 2
        const circumference = radius * Math.PI * 2;

        const maxTime = 10000; // in miliseconds
        const timesPerSec = 100
        
        let sliderInterval      = null
        let timeElapsed         = 0
        let isAutoPlaying       = true;
        let playingBeforModal   = true;
        let resizeTimeout       = null;
        let lastScreenW         = 0;

        //////////////////////////////////////////////////////////////////////////////////////////////// update mobile/desktop video background if any
        const responsiveVideoUpdate = function () {
            if (slidesVideos.length > 0 && window.innerWidth  != lastScreenW) 
                {
                lastScreenW = window.innerWidth                             // used to make sure only width is changing. mobile devices ad a menu that makes the window smaller vertically
                if (window.innerWidth <= 900) 
                    {
                    for (let i = 0; i < slidesVideos.length; i++) 
                        {
                        const vid = slidesVideos[i];
                        const url = vid.dataset.mob;
                        if (url != "none") { vid.src = url }
                        }
                    }
                else 
                    {
                    for (let i = 0; i < slidesVideos.length; i++) 
                        {
                        const vid = slidesVideos[i];
                        const url = vid.dataset.desk;
                        vid.src = url;
                        }
                    }
                }
        }

        //////////////////////////////////////////////////////////////////////////////////////////////// stop videos
        const playAllVids = function (willPlay) {
            let vids = document.querySelectorAll('video')

            if (willPlay) {
                for (let i = 0; i < vids.length; i++) { vids[i].play(); }
            }
            else {
                for (let i = 0; i < vids.length; i++) { vids[i].pause(); }
            }
        }

        //////////////////////////////////////////////////////////////////////////////////////////////// video controls for when popup opens/closes
        if (slidesVideos.length > 0 && modalTriggers.length > 0) {
            // modal trigger buttons in slideshow stop all videos
            for (let i = 0; i < modalTriggers.length; i++) {
                modalTriggers[i].addEventListener("click", function (e) {
                    playAllVids(false);
                    isAutoPlaying = false
                    toggleInterval(isAutoPlaying)
                });
            }
            /* not needed because the observer sees when modal disapears instead of when close button is pressed */
            // the modal buttons should start the videos again. but modal is created dynamically so we need this:
            // document.addEventListener("click", function(e){
            //     const closeButton = e.target.closest(".bmi-modal__close");  
            //     const modalWindow = e.target.closest(".vm--overlay");  
            //     if(modalWindow || closeButton)
            //         {playAllVids(true);}
            //   });

            //////////////////////////////////////////////////////////////////////////////////////////////// modal observer
            const observerConfig = { subtree: true, attributes: true, childList: true }
            const observer = new MutationObserver(function (mutationList) {
                const watchedTarget = document.querySelector('#modals-container .vm--container')
                for (const mutation of mutationList) {
                    if (mutation.type === 'childList') {
                        if (watchedTarget == null) {
                            playAllVids(true);
                            if (playingBeforModal == true) {
                                isAutoPlaying = true;
                                clearInterval(sliderInterval);  // must be cleared before toggle... or multiple intervals will be added.
                                toggleInterval(true)
                            }
                        }
                    }
                }
            });
            observer.observe(document.body, observerConfig);

        }



        //////////////////////////////////////////////////////////////////////////////////////////////// show percent progress
        const updateProgress = () => {
            timeElapsed += timesPerSec;
            const progress = timeElapsed / maxTime;
            const dash = progress * circumference
            circle.setAttribute("stroke-dasharray", `${dash}  ${circumference - dash}`);

            if (progress >= 1) { showSlide(1) }
        }

        //////////////////////////////////////////////////////////////////////////////////////////////// toggle interval
        const toggleInterval = function (isOn) {
            if (isOn === true) {
                sliderInterval = window.setInterval(function () { updateProgress() }, timesPerSec);
            }
            else { clearInterval(sliderInterval) }
        }

        //////////////////////////////////////////////////////////////////////////////////////////////// called on arrow click and with auto play
        const showSlide = function (direction) {
            timeElapsed = 0
            activeSlide += direction

            if (activeSlide > totalSlides) { activeSlide = 1 }
            if (activeSlide < 1) { activeSlide = totalSlides }

            slideshowEl.querySelector('.slide.active-slide').classList.remove('active-slide')
            slideshowEl.querySelector(`.slide:nth-child(${activeSlide})`).classList.add('active-slide')
        }
        //////////////////////////////////////////////////////////////////////////////////////////////// arrows
        arrowL.addEventListener("click", function (e) {
            e.preventDefault();
            showSlide(-1);
        });
        arrowR.addEventListener("click", function (e) {
            e.preventDefault();
            showSlide(1)
        });
        pausePlay.addEventListener("click", function (e) {
            e.preventDefault();
            pausePlay.classList.toggle('playing')
            isAutoPlaying = !isAutoPlaying
            toggleInterval(isAutoPlaying);

            playingBeforModal = isAutoPlaying; // used when closing modal
        });

        //////////////////////////////////////////////////////////////////////////////////////////////// start interval as soon as script loads
        toggleInterval(true)
        //////////////////////////////////////////////////////////////////////////////////////////////// update mobile videos if there are any
        responsiveVideoUpdate();
        window.onresize = function () 
            {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(responsiveVideoUpdate, 1000);             // add short delay so that video is only updated when user stops resizing;             
            };
    }


    if (slideshowEl) {
        // if there is more than one slide start slideshow auto play and its timer
        if (slidesEl.length > 1) { SlideshowConstructor(); }
        // if there is only one dont start the timer and hide the controls for moving/p
        else { slideshowEl.querySelector('.slider-controls').classList.add('hide'); }
    }
}

export default Slideshow;
